<template>
	<div>
		<div
			class="dropzone-container"
			@dragover="dragover"
			@dragleave="dragleave"
			@drop="drop"
		>
			<input
				type="file"
				name="file"
				id="fileInput"
				class="hidden-input"
				@change="onChange"
				ref="file"
				accept=".pdf,.jpg,.jpeg,.png"
			/>

			<label for="fileInput" class="file-label">
				<div v-if="isDragging">Release to drop Image here.</div>
				<div v-else>
					<div class="text">Drop image here to upload</div>
					<div class="or">OR</div>
					<span class="button">Choose picture</span>
				</div>
			</label>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isDragging: false,
			files: [],
		};
	},
	methods: {
		onChange() {
			this.files = [...this.$refs.file.files];
			this.file = this.files[0];
			this.$emit("file", this.file);
		},
		dragover(e) {
			e.preventDefault();
			this.isDragging = true;
		},
		dragleave() {
			this.isDragging = false;
		},
		drop(e) {
			e.preventDefault();
			this.$refs.file.files = e.dataTransfer.files;
			this.onChange();
			this.isDragging = false;
		},
	},
};
</script>

<style lang="scss">
.text {
	@media screen and (max-width: 799px) {
		display: none;
	}
}
.or {
	color: #ccc;
	font-size: 20px;
	margin: 10px 0 15px 0;
	@media screen and (max-width: 799px) {
		display: none;
	}
}

.button {
	width: 100px;
	background: #851a1b;
	color: white;
	padding: 8px;
	border-radius: 4px;
	font-size: 5vw;
	font-family: "Source Serif Pro", serif;
	@media screen and (min-width: 800px) {
		font-size: 22px;
	}
}
.dropzone-container {
	background: #fff;
	height: 100vw;
	@media screen and (min-width: 800px) {
		height: 500px;
	}
}

.hidden-input {
	opacity: 0;
	overflow: hidden;
	position: absolute;
	width: 1px;
	height: 1px;
}

.file-label {
	height: 100vw;
	display: flex;
	text-align: center;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	cursor: pointer;
	background: #fff;
	transition: background-color 0.3s ease;
	@media screen and (min-width: 800px) {
		font-size: 32px;
		height: 500px;
	}
}
.file-label:hover {
	background: #eaeaea;
}

.preview-container {
	display: flex;
	margin-top: 2rem;
}

.preview-card {
	display: flex;
	border: 1px solid #a2a2a2;
	padding: 5px;
	margin-left: 5px;
}

.preview-img {
	width: 50px;
	height: 50px;
	border-radius: 5px;
	border: 1px solid #a2a2a2;
	background-color: #a2a2a2;
}
</style>
